export default function date (input) {
    if (!input) return ''
    // Ex: 5144567876 devient (514) 456-7876
    return `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6)}`
}
